import {
  CHAT_NAV_BAR_CLEARANCE,
  CHAT_VIEWPORT_INSET_BOTTOM,
  CHAT_VIEWPORT_INSET_X,
} from "./consts";

export interface ChatArea {
  bottom: number;
  left: number;
  right: number;
  top: number;
}

/**
 * The region a chat window's rect has to stay inside, in viewport coordinates.
 *
 * Every bound in the widget derives from this one function, so "how much room is there"
 * has a single answer that does not depend on where the window currently sits. The top
 * bound clears the nav bar; the other three keep the same insets the collapsed launcher
 * sits at.
 */
const getChatArea = (viewportWidth: number, viewportHeight: number): ChatArea => ({
  bottom: viewportHeight - CHAT_VIEWPORT_INSET_BOTTOM,
  left: CHAT_VIEWPORT_INSET_X,
  right: viewportWidth - CHAT_VIEWPORT_INSET_X,
  top: CHAT_NAV_BAR_CLEARANCE,
});

export default getChatArea;
